import { H1, useBreadcrumbs } from "@inmagik/magik-ui"
import Layout from "../../components/Layout"
import { Tavola } from "../../types"
import { useNavigate } from "react-router-dom"
import { Formik } from "formik"
import { Container } from "react-bootstrap"
import BottomFormFixed from "../../components/BottomFormFixed"
import { initialValuesTavola, validationSchemaTavola} from "./TavolaCommon"
import TavolaForm from "./TavolaForm"
import { useMemo } from "react"
import { ScrollLayout } from "../../components/ScrollLayout"
import { transformErrorForForm } from "../../utils/utils"
import { useTavolaCreate } from "../../hooks/tavole"

export default function TavolaCreate() {
  const createTavola = useTavolaCreate()
  const navigate = useNavigate()

  useBreadcrumbs([{ label: "Tavole", href: "/atlanti/tavole" }, { label: "Creazione Tavola" }])

  const initialValues = useMemo(() => initialValuesTavola(), [])
  const validationSchema = useMemo(() => validationSchemaTavola(true), [])

  return (
    <Layout>
      <ScrollLayout hasBottomFixed>
        <H1>Nuova tavola</H1>
        <ScrollLayout.Scroll>
          <Formik
            enableReinitialize
            initialValues={initialValues}
            validationSchema={validationSchema}
            onSubmit={(values, actions) => {
              return createTavola.mutateAsync(values as Tavola).then((tavola) => {
                navigate(`/atlanti/tavole/`)
              }).catch((e) => {
                actions.setErrors(transformErrorForForm(e))
              })
            }}
          >
            {({ handleSubmit }) => (
              <form onSubmit={handleSubmit}>
                <Container fluid className="mt-6" style={{ marginBottom: "100px" }}>
                  <TavolaForm hasAtalante col={8} />
                </Container>
                <BottomFormFixed url="/atlanti/tavole" />
              </form>
            )}
          </Formik>
        </ScrollLayout.Scroll>
      </ScrollLayout>
    </Layout>
  )
}
